import { Component, EventEmitter, OnInit, Output, signal } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { PermissionService } from 'src/app/auth/services/permission.service';
import { DISPLAY_ACCESS } from 'src/app/auth/types/access-level';
import { DisplayService } from '../../services/display.service';
import { PlayerProService } from '../../services/player-pro.service';
import { ScreenshotService } from '../../services/screenshot.service';

@Component({
  selector: 'screenshot',
  templateUrl: './screenshot.component.html',
  styleUrls: ['./screenshot.component.scss'],
  standalone: false,
})
export class ScreenshotComponent implements OnInit {
  @Output() licenseRequired: EventEmitter<void> = new EventEmitter<void>();

  get screenshotUrl(): SafeUrl {
    return this.domSanitizer.bypassSecurityTrustUrl(
      this.screenshotService.screenshot?.imageUrl || '',
    );
  }

  get lastModified(): Date | undefined {
    return this.screenshotService.screenshot?.lastModified;
  }

  get shouldRotate(): boolean {
    return (
      !this.displayService.isGiadaDisplay() &&
      !this.displayService.hasPortraitResolution() &&
      this.displayService.isOrientationPortrait()
    );
  }

  get hasDisplayFullAccess(): boolean {
    return this.permissionService.hasAccess(DISPLAY_ACCESS.FULL_ACCESS);
  }

  protected orientation = signal<string>('0');

  constructor(
    public displayService: DisplayService,
    public screenshotService: ScreenshotService,
    private permissionService: PermissionService,
    public playerProService: PlayerProService,
    private domSanitizer: DomSanitizer,
  ) {}

  ngOnInit(): void {
    this.orientation.set(
      this.shouldRotate ? this.displayService.display?.orientation : '0',
    );
  }

  screenshotState() {
    if (
      !this.playerProService.isScreenshotCompatiblePlayer(
        this.displayService.display,
      )
    ) {
      return 'not-supported';
    } else if (this.displayService.showLicenseRequired()) {
      return 'no-license';
    } else if (
      !this.displayService.display ||
      this.screenshotService.screenshotLoading
    ) {
      return 'loading';
    } else if (
      this.screenshotService.screenshot &&
      this.screenshotService.screenshot.lastModified
    ) {
      return 'screenshot-loaded';
    } else if (
      this.screenshotService.screenshot &&
      this.screenshotService.screenshot.error
    ) {
      return 'screenshot-error';
    }

    return '';
  }

  reloadScreenshotEnabled() {
    if (!this.displayService.display) {
      return false;
    }

    if (this.displayService.showLicenseRequired()) {
      return false;
    } else if (
      this.screenshotService.screenshotLoading ||
      !this.screenshotService.screenshot
    ) {
      return false;
    } else if (this.displayService.display.onlineStatus === 'online') {
      return true;
    }

    return false;
  }

  confirmLicensing() {
    this.licenseRequired.emit();
  }
}
